export default __webpack_public_path__ + "static/skeletongeneral_scaled-31105d47fce69079b082399ac5f00c3c.gif";